import React from "react";
import { PROD } from '../../../common/constants';
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CreateAndSendRatesToStakeholders from "./createAndSendRatesToStakeholders";
import ApprovedRatesFromSTakeholders from "./approvedRatesFromStakeholders";

function RateCardConfirmation() {

  const [tabValue, setTabValue] = React.useState('create');
  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
};

  return (
    <>
      <TabContext value={tabValue}>
        {!PROD && <p style={{ textAlign: "right", fontSize: "2vh" }}>RES17</p>}
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleTabChange} aria-label="lab API tabs example">
            <Tab label="Create and Send Rates to Stakeholders" value="create" />
            <Tab label="All Rates" value="approved" />
          </TabList>
        </Box>
        <TabPanel value="create"><CreateAndSendRatesToStakeholders /></TabPanel>
        <TabPanel value="approved"><ApprovedRatesFromSTakeholders /></TabPanel>
      </TabContext>
    </>
  );
}
export default RateCardConfirmation;
